import { getLocalizedValue } from '@grandvisionhq/utils';

const mapCommerceToolsOfferingToOffering = (offering, locale)=>{
    var ref;
    return {
        title: getLocalizedValue(offering.title, locale),
        subTitle: getLocalizedValue(offering.subTitle, locale),
        sku: offering.sku,
        icon: offering.icon,
        originalPriceInformation: offering.price ? {
            amount: offering.price.value.centAmount,
            currencyCode: offering.price.value.currencyCode
        } : undefined,
        discountedPriceInformation: ((ref = offering.price) === null || ref === void 0 ? void 0 : ref.discounted) ? {
            amount: offering.price.discounted.value.centAmount,
            currencyCode: offering.price.discounted.value.currencyCode
        } : undefined,
        isInsuranceReimbursable: offering.isInsuranceReimbursable
    };
};

export { mapCommerceToolsOfferingToOffering };
//# sourceMappingURL=map-ct-offering-to-offering.js.map
